﻿import React, { useState, useRef, useEffect} from 'react';
import { createFocusTrap } from 'focus-trap';

export const Lightbox = (props) => {
  const backgroundRef = useRef(null);

  const [requestAnimation, setRequestAnimation] = useState(false);
  const [maxHeight, setMaxHeight] = useState({ maxHeight: '100%' });

  const closeHandler = (e) => {
		if (!e || e.target === backgroundRef.current) {
      window.removeEventListener('resize', initMaxHeight);
      props.onCloseEvent();
    }
  };

  const initMaxHeight = (e) => {
    if (!requestAnimation) {
      window.requestAnimationFrame(() => {
        setMaxHeight({ maxHeight: `${window.innerHeight}px` });
        setRequestAnimation(false);
      });
    }

    setRequestAnimation(false);
  };

  useEffect(() => {
    window.addEventListener('resize', initMaxHeight);
    return () => window.removeEventListener('resize', initMaxHeight);
  }, [])

  useEffect(() => {
		//Focus trap
		const overlayFocusTrap = createFocusTrap(backgroundRef.current);
		overlayFocusTrap.activate();

		return () => { overlayFocusTrap.deactivate(); }
  }, [])

  return (
    <div className="single-step__lightbox" ref={backgroundRef} onClick={(e) => closeHandler(e)}>
      <section className="single-step__lightbox__inner" style={maxHeight}>
        <header>
          { props.heading ?? <span>&nbsp;</span> }
          <button onClick={() =>closeHandler(null)} className="single-step__lightbox__close">{ props.close }</button>
        </header>
        <main>
          { props.children }
        </main>
      </section>
    </div>

  )
}
